export default __webpack_public_path__ + "mask2e5c900.png";